export default function common() {
  window.googletag = window.googletag || {cmd: []};

  googletag.cmd.push(function() {
    $('.adv-container').each(function(){
      if (isMobile()) {
        googletag.defineSlot('/106050698/SMX', [[320, 50]], $(this).attr('id')).addService(googletag.pubads());
      } else {
        googletag.defineSlot('/106050698/SMX', [[728, 90]], $(this).attr('id')).addService(googletag.pubads());
      }
    });

    $('.news-adv').each(function(){
      googletag.defineSlot('/106050698/SMX', [[300, 250]], $(this).attr('id')).addService(googletag.pubads());
    });

    googletag.pubads().enableSingleRequest();
    googletag.enableServices();

    $('.adv-container, .news-adv').each(function(){
      googletag.display($(this).attr('id'));
    });
  });
}

const isMobile = () => {
  return $(window).width() < 992;
}

export { isMobile };
